import { Controller } from "@hotwired/stimulus"
//import Chart from "chart.js/auto"

export default class extends Controller {
  static values = {
    data: Array,
    colors: Array,
    title: String,
    breakdownType: String,
    orientation: { type: String, default: "vertical" }
  }

  connect() {
    console.log("Claims breakdown chart controller connected")

    this.createChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  createChart() {
    console.log("Creating claims breakdown chart...")

    if (this.chart) {
      console.log("Chart already exists, skipping")
      return
    }

    console.log("Element:", this.element)
    console.log("Data:", this.dataValue)
    console.log("Colors:", this.colorsValue)
    console.log("Breakdown Type:", this.breakdownTypeValue)
    console.log("Orientation:", this.orientationValue)

    const chartData = this.prepareChartData()
    console.log("Prepared chart data:", chartData)

    // Detect if we're in a PDF/print context
    const isPrintContext = window.matchMedia && window.matchMedia('print').matches

    const isHorizontal = this.orientationValue === "horizontal"

    this.chart = new Chart(this.element, {
      type: "bar",
      data: chartData,
      options: {
        indexAxis: isHorizontal ? "y" : "x",
        animation: false, // Disable animations for PDF rendering
        responsive: true, //!isPrintContext, // Disable responsive in print context
        maintainAspectRatio: false,
        //aspectRatio: 3.0, // width:height = 3:1
        devicePixelRatio: 2.0, // Higher resolution for PDFs
        plugins: {
          title: {
            display: true,
            text: this.titleValue || `Claims by ${this.breakdownTypeValue}`
          },
          legend: {
            display: false  // Single series doesn't need legend
          }
        },
        scales: {
          y: isHorizontal ? {
            ticks: {
              autoSkip: false
            },
            grid: {
              drawBorder: false,
              display: false
            }
          } : {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return "$" + value.toLocaleString()
              }
            },
            grid: {
              drawBorder: false,
              display: false
            }
          },
          x: isHorizontal ? {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return "$" + value.toLocaleString()
              }
            },
            grid: {
              drawBorder: false,
              display: false
            }
          } : {
            ticks: {
              maxRotation: 45,
              minRotation: 45
            },
            grid: {
              drawBorder: false,
              display: false
            }
          }
        }
      }
    })

    console.log("Claims breakdown chart created successfully")
  }

  prepareChartData() {
    const data = this.dataValue
    const [primaryColor] = this.colorsValue

    // Safety check for data
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.warn("No data provided for claims breakdown chart")
      return {
        labels: [],
        datasets: []
      }
    }

    // Filter out total rows and extract labels and amounts
    const filteredData = data.filter(row =>
      row &&
      row.item &&
      !row.item.toString().toLowerCase().includes("total")
    )

    if (filteredData.length === 0) {
      console.warn("No valid data after filtering")
      return {
        labels: [],
        datasets: []
      }
    }

    const labels = filteredData.map(row => row.item || "Unknown")

    // Extract amount paid data, converting string currency to numbers
    const amounts = filteredData.map(row => {
      let amount = row.amount_paid || 0

      // Convert currency string to number (remove $, commas, etc.)
      if (typeof amount === "string") {
        amount = amount.replace(/[$,]/g, "")
        amount = parseFloat(amount) || 0
      }

      return typeof amount === "number" ? amount : 0
    })

    const result = {
      labels: labels,
      datasets: [
        {
          label: "Amount Paid",
          data: amounts,
          backgroundColor: primaryColor,
          borderColor: primaryColor,
          borderWidth: 1
        }
      ]
    }

    console.log("Claims breakdown chart data:", result)

    return result
  }
}
